import React from "react";

const Section12Termination = () => (
  <>
    <h2>12. Termination</h2>
    <p>
    You may terminate your Account and these Terms at any time through your Account settings or by contacting us. Comparedly Ltd. reserves the right to suspend or terminate your access to the Service at any time, with or without cause, upon notice to you. Reasons for termination may include, but are not limited to, your violation of these Terms, non-payment of subscription fees, or any activity that disrupts or interferes with the Service or other users' experience. Upon termination, your right to access and use the Service will immediately cease. Comparedly Ltd. may retain your Content for a commercially reasonable period for backup, archival, or audit purposes, unless otherwise required by law. Any provisions of these Terms that by their nature should survive termination shall so survive, including but not limited to intellectual property rights, confidentiality, warranties and disclaimers, limitations of liability, and indemnification.
    </p>

  </>
);

export default Section12Termination;
